export default __webpack_public_path__ + "static/media/logo-oneplanet.9624dec0.svg";